<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                tile
                @click="$emit('click', $event)"
                :to="to"
                :disabled="disabled"
                :href="href"
                :target="target"
            >
                <v-icon :color="color" v-on="on">{{ icon }}</v-icon>
            </v-btn>
        </template>
        <span v-if="label">{{ label }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: 'blue-grey',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
        },
        to: {
            default: undefined,
        },
        href: {
            default: undefined,
        },
        target: {
            default: undefined,
        },
    },
}
</script>

<style></style>
